import React from 'react';
import { alpha } from "@mui/material/styles";
import { Box, Typography, useTheme } from "@mui/material";
import ProgressCircle from "./ProgressCircle";
import { tokens } from "../theme";


const StatBox = ({ title, subtitle, icon, progress, increase }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Check if progress is a valid React element (like a button)
  const isCustomComponent = React.isValidElement(progress);

  return (
    <Box
      width="100%"
      sx={{
        p: 2.5,
        borderRadius: "18px",
        backgroundColor: colors.primary[400],
        border: `1px solid ${alpha(colors.grey[100], 0.08)}`,
        boxShadow: "0 10px 26px rgba(0, 0, 0, 0.18)",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Box>
          <Box
            sx={{
              width: 48,
              height: 48,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "14px",
              backgroundColor: alpha(colors.blueAccent[500], 0.24),
              mb: 1.5,
            }}
          >
            {icon}
          </Box>
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ color: colors.grey[100] }}
          >
            {title}
          </Typography>
        </Box>
        <Box>
          {isCustomComponent ? progress : <ProgressCircle progress={progress} />}
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="flex-end" mt={1.5} gap={2}>
        <Typography
          variant="body1"
          sx={{
            color: colors.grey[100],
            maxWidth: "72%",
            lineHeight: 1.5,
            fontWeight: 700,
          }}
        >
          {subtitle}
        </Typography>
        <Typography
          variant="body2"
          fontWeight={700}
          sx={{ color: colors.greenAccent[600], whiteSpace: "nowrap" }}
        >
          {increase}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatBox;
